<template>
  <div class="default-table m-0 border-none shadow-none table-tags">
    <div class="d-flex justify-content-between align-items-center px-3 mb-1">
      <div class="d-flex align-items-center">
        <span class="text-default">
          Tags
        </span>
      </div>
      <span class="text-muted">Optional</span>
    </div>
    <b-table
      ref="table"
      class="tags loaded"
      table-class="m-0 p-0"
      :items="items"
      :fields="fields"
      responsive
    >
      <template #cell(tagKey)="data">
        <validation-provider
          #default="{ errors }"
          :vid="`key${data.item.id}`"
          name="Key"
          rules="required"
        >
          <b-form-input
            :id="`key-${data.item.id}`"
            v-model="data.item.tagKey"
            :disabled="tagKeys.includes(data.item.id)"
            placeholder="Enter tag key here..."
            class="m-0"
          />
          <small
            v-if="checkKeys(data.item.tagKey)"
            class="text-danger errorContainer"
          >Tag key duplication detected. Only the first one will be
            added.</small>
          <small
            v-if="errors[0]"
            class="text-danger"
          >The tag key field is required</small>
        </validation-provider>
      </template>
      <template #cell(tagValue)="data">
        <validation-provider
          #default="{ errors }"
          :vid="data.item.id"
          name="Name"
          rules="required"
        >
          <b-form-input
            :id="data.item.id"
            v-model="data.item.tagValue"
            placeholder="Enter tag value here..."
            class="m-0"
          />
          <small
            v-if="errors[0]"
            class="text-danger"
          >The tag value field is required</small>
        </validation-provider>
      </template>
      <template #cell(id)="data">
        <a @click="removeTag(data.item.id)">
          <GjIcon name="Delete" />
        </a>
      </template>
    </b-table>
    <div class="px-3 mt-1">
      <a
        class="text-primary text-medium"
        @click="addTag"
      >
        + Add Tag
      </a>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { required } from '@validations'
import { ValidationProvider } from 'vee-validate'
import bucketsInfo from '../bucketsInfo'

export default {
  name: 'Tags',
  components: { ValidationProvider },
  props: {
    details: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      required,
      bucketsInfo,
      items: [],
      fields: [
        'tagKey',
        'tagValue',
        {
          key: 'id',
          label: '',
        },
      ],
    }
  },
  computed: {
    bucketTags() {
      return this.$store.state.accountBuckets.bucketTags
    },
    tagKeys() {
      return this.$store.state.accountBuckets.tagKeys
    },
  },
  watch: {
    items() {
      this.$emit('updateTags', this.items)
    },
  },
  created() {
    if (this.details) {
      this.items = this.formatTagsOnDetails()
    }
  },
  methods: {
    removeTag(val) {
      this.items = this.items.filter(item => item.id !== val)
    },
    formatTagsOnDetails() {
      return this.bucketTags.map(tag => ({
        tagKey: tag.key,
        tagValue: tag.value,
        id: uuidv4(),
      }))
    },
    addTag() {
      this.items.push({ tagKey: '', tagValue: '', id: uuidv4() })
    },
    checkKeys(value) {
      return (
        this.items.filter(item => item.tagKey.length && item.tagKey === value)
          .length > 1
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.tags::v-deep {
  tr {
    td {
      vertical-align: initial;
    }
  }
}
.errorContainer {
  white-space: initial;
}
</style>
